import React, { Component } from "react";
import axios from "axios";
import { FormControl, Button, Glyphicon, HelpBlock, Nav, NavItem } from "react-bootstrap";
import { EDFormSection, EDFormBox, EDFormGroup, EDTabs } from "../components/EDDOM";
import LoaderPanel from "../components/LoaderPanel";
import LoaderButton from "../components/LoaderButton";
import withLoadSave from "../components/LoadSave";
import { FormControlLabel, SelectLabel, CheckboxLabel } from "../components/FormControls";
import SaveNavbar from "../components/SaveNavbar";
import getImage from "../utils/get-image";
import getvalue from "../utils/getvalue";
import _ from "underscore";

const defheaders = `From: {{!!from}}
Reply-To: {{!!replyto}}
To: {{!!to}}
Subject: {{!!subject}}
Date: {{!!date}}
MIME-Version: 1.0
Content-Type: text/html; charset="utf-8"
Content-Transfer-Encoding: quoted-printable
Message-ID: <{{!!msgid}}>
List-Unsubscribe: <{{!!unsubheaderlink}}>
`;

class Frontend extends Component {
  constructor(props) {
    super(props);

    this.state = { activeKey: '1' };
  }

  switchView = v => {
    this.setState({activeKey: v});
  }

  validateForm() {
    var d = this.props.data;
    if (!d.name.length || d.bouncerate === '' ||
        d.complaintrate === '' || !d.invitename || !d.inviteemail ||
        d.hourlimit === null || d.daylimit === null || d.trialdays === null)
      return false;
    for (var i = 0; i < d.domainrates.length; i++) {
      var r = d.domainrates[i];

      if (r.bouncerate === '' || r.complaintrate === '')
        return false;
    }
    return true;
  }

  handleChange = event => {
    this.props.update({[event.target.id]: {$set: getvalue(event)}})
  }

  handleDomainChange = (index, event) => {
    this.props.update({domainrates: {[index]: {[event.target.id]: {$set: getvalue(event)}}}})
  }

  addDomain = event => {
    event.preventDefault();
    this.props.update({domainrates: {$splice: [[0, 0, {
      domain: '',
      bouncerate: 3.0,
      complaintrate: 0.2
    }]]}});
  }

  removeDomain = (index, event) => {
    event.preventDefault();

    this.props.update({domainrates: {$splice: [[index, 1]]}});
  }

  handleSubmit = async event => {
    event.preventDefault();

    await this.onSave();

    this.goBack();
  }

  onSave = async () => {
    await this.props.save();
  }

  goBack = () => {
    this.props.history.push("/frontends");
  }

  uploadClick = () => {
    document.getElementById('file').click();
  }

  handleImage = async event => {
    if (event.target.files.length === 0)
      return
    var file = event.target.files[0];

    var props = this.props;

    getImage(file, 300, data => {
      props.update({image: {$set: data}});
    });
  }

  resetClick = () => {
    this.props.update({headers: {$set: defheaders}});
  }

  navbarButtons = () => {
    return (
      <LoaderButton
        id="frontend-buttons-dropdown"
        text="Save and Close"
        loadingText="Saving..."
        className="green"
        disabled={!this.validateForm() || this.props.isSaving}
        onClick={this.handleSubmit}
        splitItems={[
          { text: 'Save', onClick: this.onSave },
          { text: 'Cancel', onClick: this.goBack }
        ]}
      />
    )
  }

  render() {
    var txnopts = [];
    if (this.props.mailgun) {
      txnopts = _.sortBy(this.props.mailgun.concat(this.props.ses), o => o.name.toLowerCase());
    }

    return (
      <LoaderPanel isLoading={this.props.isLoading}>
        <SaveNavbar isAdmin={true} title={this.props.id === 'new'?'Create Frontend':'Edit Frontend'} isSaving={this.props.isSaving}
          onBack={this.goBack} disabled={!this.validateForm()} buttons={this.navbarButtons()} id={this.props.id}>
          <EDFormSection onSubmit={this.handleSubmit}>
            <EDTabs>
              <Nav className="nav-tabs" activeKey={this.state.activeKey}>
                <NavItem eventKey="1" disabled={this.state.activeKey==='1'} onClick={this.switchView.bind(null, '1')}>Profile</NavItem>
                <NavItem eventKey="2" disabled={this.state.activeKey==='2'} onClick={this.switchView.bind(null, '2')}>Settings</NavItem>
                <NavItem eventKey="3" disabled={this.state.activeKey==='3'} onClick={this.switchView.bind(null, '3')}>Broadcast Alert Thresholds</NavItem>
                <NavItem eventKey="4" disabled={this.state.activeKey==='4'} onClick={this.switchView.bind(null, '4')}>Default Send Limits</NavItem>
                <NavItem eventKey="5" disabled={this.state.activeKey==='5'} onClick={this.switchView.bind(null, '5')}>Header Template</NavItem>
                <NavItem eventKey="6" disabled={this.state.activeKey==='6'} onClick={this.switchView.bind(null, '6')}>Signup Emails</NavItem>
              </Nav>
            </EDTabs>
            <EDFormBox space style={{display:this.state.activeKey==='1'?undefined:'none'}}>
              <FormControlLabel
                id="name"
                label="Name"
                obj={this.props.data}
                onChange={this.handleChange}
              />
              <EDFormGroup space>
                <FormControl id="file" type="file" onChange={this.handleImage} accept="image/*" style={{display: 'none'}}/>
                <label>Brand Image</label>
                <div>
                {
                  !this.props.data.image ?
                    <div style={{width:'100px', height: '100px', position: 'relative', border: 'gray solid 1px'}} onClick={this.uploadClick}>
                      <Glyphicon glyph="camera" style={{position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        marginLeft: '-16px',
                                                        marginTop: '-16px',
                                                        cursor: 'pointer',
                                                        fontSize: '32px'}}/>
                    </div>
                    :
                    <img style={{backgroundColor: '#4c84ff', height: '72px', display: 'block', cursor: 'pointer'}} src={this.props.data.image} alt="" onClick={this.uploadClick}></img>
                  }
                  </div>
                <HelpBlock>Click to upload</HelpBlock>
                <HelpBlock>Recommended dimensions: 72 x 72</HelpBlock>
              </EDFormGroup>
            </EDFormBox>
            <EDFormBox space style={{display:this.state.activeKey==='2'?undefined:'none'}}>
              <FormControlLabel
                id="bodydomain"
                label="Template Link Domain (optional)"
                obj={this.props.data}
                onChange={this.handleChange}
                placeholder="Use link domain configured under Servers"
                space
              />
              <CheckboxLabel
                id="usedkim"
                label="Enable DKIM (If Configured)"
                obj={this.props.data}
                onChange={this.handleChange}
                space
              />
              <h5 className="text-center">These settings are only for mail sent via Velocity MTA, not for SMTP Relay or API accounts</h5>
            </EDFormBox>
            <div style={{display:this.state.activeKey==='3'?undefined:'none', textAlign: 'left'}} className="space20">
              <h4 style={{margin: '0 auto', width: '90%'}}>Global Settings</h4>
              <EDFormBox space className="form-inline">
                <div>
                  <FormControlLabel
                    id="bouncerate"
                    label="Show Alert on Bounces Higher Than"
                    obj={this.props.data}
                    onChange={this.handleChange}
                    type="number"
                    style={{width:'75px', textAlign: 'right'}}
                    min="0"
                    max="100"
                    step="0.1"
                    inline
                  />{' '}%
                </div>
                <div className="space20">
                  <FormControlLabel
                    id="complaintrate"
                    label="Show Alert on Complaints Higher Than"
                    obj={this.props.data}
                    onChange={this.handleChange}
                    type="number"
                    style={{width:'75px', textAlign: 'right'}}
                    min="0"
                    max="100"
                    step="0.1"
                    inline
                  />{' '}%
                </div>
              </EDFormBox>
              <h4 className="space30" style={{margin: '0 auto', width: '90%'}}>
                Per-Domain Settings
                <div className="pull-right">
                  <Button onClick={this.addDomain} disabled={this.props.data.domainrates.length >= 5}>
                    <Glyphicon glyph="plus" />
                    Add Setting
                  </Button>
                </div>
              </h4>
              {
                _.map(this.props.data.domainrates, (d, i) => (
                  <EDFormBox space className="form-inline" key={i}>
                    <FormControlLabel
                      id="domain"
                      label="Domain:"
                      obj={d}
                      onChange={this.handleDomainChange.bind(null, i)}
                      style={{width: '300px'}}
                      inline
                    />
                    {
                      this.props.data.domainrates.length > 1 &&
                        <div className="pull-right">
                          <Button onClick={this.removeDomain.bind(null, i)}>
                            <Glyphicon glyph="remove" />
                          </Button>
                        </div>
                    }
                    <div className="space20">
                      <FormControlLabel
                        id="bouncerate"
                        label="Show Alert on Bounces Higher Than"
                        obj={d}
                        onChange={this.handleDomainChange.bind(null, i)}
                        type="number"
                        style={{width:'75px', textAlign: 'right'}}
                        min="0"
                        max="100"
                        step="0.1"
                        inline
                      />{' '}%
                    </div>
                    <div className="space20">
                      <FormControlLabel
                        id="complaintrate"
                        label="Show Alert on Complaints Higher Than"
                        obj={d}
                        onChange={this.handleDomainChange.bind(null, i)}
                        type="number"
                        style={{width:'75px', textAlign: 'right'}}
                        min="0"
                        max="100"
                        step="0.1"
                        inline
                      />{' '}%
                    </div>
                  </EDFormBox>
                ))
              }
            </div>
            <div style={{display:this.state.activeKey==='4'?undefined:'none', textAlign: 'left'}} className="space20">
              <EDFormBox space>
                <CheckboxLabel
                  id="useapprove"
                  label="Require Approval Before Activing Free Accounts"
                  obj={this.props.data}
                  onChange={this.handleChange}
                />
                <CheckboxLabel
                  id="usetrial"
                  label="Time Limit Free Trial"
                  obj={this.props.data}
                  onChange={this.handleChange}
                />
                <FormControlLabel
                  id="trialdays"
                  label="Trial Days"
                  obj={this.props.data}
                  onChange={this.handleChange}
                  type="number"
                  min="1"
                  style={{width: '90px'}}
                  disabled={!this.props.data.usetrial}
                />
                <FormControlLabel
                  id="hourlimit"
                  label="Hourly Send Limit for New Customers"
                  obj={this.props.data}
                  onChange={this.handleChange}
                  type="number"
                  min="0"
                  style={{width: '90px'}}
                />
                <FormControlLabel
                  id="daylimit"
                  label="Daily Send Limit for New Customers"
                  obj={this.props.data}
                  onChange={this.handleChange}
                  type="number"
                  min="0"
                  style={{width: '90px'}}
                />
                <FormControlLabel
                  id="initiallimit"
                  label="Initial Daily Limit for New Customers"
                  obj={this.props.data}
                  onChange={this.handleChange}
                  type="number"
                  min="0"
                  style={{width: '90px'}}
                />
                <FormControlLabel
                  id="limitincr"
                  label="Limit Increase % for New Customers"
                  obj={this.props.data}
                  onChange={this.handleChange}
                  type="number"
                  min="0"
                  step="0.01"
                  style={{width: '90px'}}
                />
                <FormControlLabel
                  id="limitincrmins"
                  label="Increase Wait Time (Mins) for New Customers"
                  obj={this.props.data}
                  onChange={this.handleChange}
                  type="number"
                  min="1"
                  style={{width: '90px'}}
                />
                <div className="space20 form-inline">
                  <FormControlLabel
                    id="bouncethreshold"
                    label="Pause Sending if Bounces Higher Than"
                    obj={this.props.data}
                    onChange={this.handleChange}
                    type="number"
                    style={{width:'75px', textAlign: 'right'}}
                    min="0"
                    max="100"
                    step="0.1"
                    inline
                  />{' '}%
                </div>
                <div className="space20 form-inline">
                  <FormControlLabel
                    id="unsubthreshold"
                    label="Pause Sending if Unsubscribes Higher Than"
                    obj={this.props.data}
                    onChange={this.handleChange}
                    type="number"
                    style={{width:'75px', textAlign: 'right'}}
                    min="0"
                    max="100"
                    step="0.1"
                    inline
                  />{' '}%
                </div>
                <div className="space20 form-inline">
                  <FormControlLabel
                    id="complaintthreshold"
                    label="Pause Sending if Complaints Higher Than"
                    obj={this.props.data}
                    onChange={this.handleChange}
                    type="number"
                    style={{width:'75px', textAlign: 'right'}}
                    min="0"
                    max="100"
                    step="0.1"
                    inline
                  />{' '}%
                </div>
              </EDFormBox>
            </div>
            <EDFormBox space style={{display:this.state.activeKey==='5'?undefined:'none'}}>
              <FormControlLabel
                id="headers"
                label="Headers"
                obj={this.props.data}
                onChange={this.handleChange}
                componentClass="textarea"
                rows="12"
                style={{fontFamily:'Courier New'}}
              />
              <div className="pull-right">
                <Button onClick={this.resetClick}>
                  Reset To Default
                </Button>
              </div>
              <SelectLabel
                id="fromencoding"
                label="From Name Encoding"
                obj={this.props.data}
                onChange={this.handleChange}
                help="When &quot;Default&quot; is selected, headers will be encoded with quoted-printable if they contain non-ascii characters"
                space
              >
                <option value="none">Default</option>
                <option value="b64">Base 64</option>
                <option value="qp">Quoted-Printable</option>
              </SelectLabel>
              <SelectLabel
                id="subjectencoding"
                label="Subject Encoding"
                obj={this.props.data}
                onChange={this.handleChange}
                space
              >
                <option value="none">Default</option>
                <option value="b64">Base 64</option>
                <option value="qp">Quoted-Printable</option>
              </SelectLabel>
              <h5 className="text-center space30">These settings are only for mail sent via Velocity MTA, not for SMTP Relay or API accounts</h5>
            </EDFormBox>
            <EDFormBox space style={{display:this.state.activeKey==='6'?undefined:'none'}}>
              <FormControlLabel
                id="invitename"
                label="From Name"
                obj={this.props.data}
                onChange={this.handleChange}
              />
              <FormControlLabel
                id="inviteemail"
                label="From Email Address"
                obj={this.props.data}
                onChange={this.handleChange}
                type="email"
              />
              <SelectLabel
                id="txnaccount"
                label="Account for Internal Transactional Mail"
                obj={this.props.data}
                onChange={this.handleChange}
                options={txnopts}
                emptyVal="Built In"
              />
            </EDFormBox>
          </EDFormSection>
        </SaveNavbar>
      </LoaderPanel>
    );
  }
}

export default withLoadSave({
  extend: Frontend,
  initial: {
    name: '',
    welcometext: 'Welcome',
    bodydomain: '',
    usedkim: true,
    bouncerate: 3.0,
    complaintrate: 0.2,
    domainrates: [{
      domain: '',
      bouncerate: 3.0,
      complaintrate: 0.2
    }],
    bouncethreshold: 99,
    unsubthreshold: 99,
    complaintthreshold: 99,
    fromencoding: 'none',
    subjectencoding: 'none',
    headers: defheaders,
    invitename: 'Welcome',
    inviteemail: 'invite@domain.com',
    useapprove: false,
    usetrial: false,
    trialdays: 10,
    hourlimit: 999999999,
    daylimit: 999999999,
    initiallimit: 999999999,
    limitincr: 0,
    limitincrmins: 0,
    txnaccount: '',
  },
  get: async ({id}) => (await axios.get('/api/frontends/' + id)).data,
  post: ({data}) => axios.post('/api/frontends', data),
  patch: ({id, data}) => axios.patch('/api/frontends/' + id, data),
  extra: {
    mailgun: async () => (await axios.get('/api/mailgun')).data,
    ses: async () => (await axios.get('/api/ses')).data,
  },
});



// WEBPACK FOOTER //
// ./src/containers/Frontend.js